export const arrayToMap = <T, U,>(array: { key: T, value: U }[]): Map<T, U> => {
  return new Map<T, U>(
    (array || []).map(
      b => [
        b.key,
        b.value
      ]));
}

export const arraysToMap = <T, U, V,>(array: { key: T, value: { key: U, value: V }[] }[]): Map<T, Map<U, V>> => {
  return new Map<T, Map<U, V>>(
    (array || []).map(
      b => [
        b.key,
        arrayToMap(b.value)
      ]));
}